// extracted by mini-css-extract-plugin
export default {"logoWrapper":"style_logoWrapper__Ar5a3","logo":"style_logo__lZOal","logoLink":"style_logoLink__Qbgqw","headerLogo":"style_headerLogo__mP1ha","FooterLogo":"style_FooterLogo__5g0t8"};